"use client";

import { ArrowUpRight, MapPin, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FindingTheVenue() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const details = [{
    label: "EVENT DATE",
    value: "Saturday, June 15th"
  }, {
    label: "BRUNCH SERVICE",
    value: "11:30 AM — 2:30 PM"
  }, {
    label: "DRESS CODE",
    value: "Garden Party Attire"
  }];
  return <section data-section-id="4816" id="finding-the-venue" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div ref={leftRef} className={`lg:col-span-5 lg:col-start-2 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <p className="font-mono text-[0.75rem] font-bold uppercase tracking-[0.2em] text-muted-foreground mb-8" style={{
            letterSpacing: "0.2em"
          }}>
              The Celebration — Venue Details
            </p>

            {}
            <h2 className="font-default text-foreground text-5xl md:text-6xl lg:text-[3.5rem] leading-[1.2] tracking-tight mb-10 relative">
              <span className="absolute -left-8 -top-12 text-[8rem] opacity-5 font-serif pointer-events-none">O</span>
              The Venue.
            </h2>

            {}
            <address className="not-italic font-serif text-foreground text-xl md:text-[1.25rem] leading-relaxed mb-10">
              The Glasshouse at Willow Creek
              <br />
              42 Heritage Lane
              <br />
              Ohlson Estate, CA 90210
            </address>

            {}
            <Separator className="bg-border/70 my-10" />

            {}
            <dl className="space-y-6 mb-12">
              {details.map((detail, i) => <div data-index={i} key={detail.label} className="grid grid-cols-1 sm:grid-cols-[1fr_1.2fr] gap-2 sm:gap-6 items-baseline">
                  <dt className="font-mono text-[0.75rem] font-bold uppercase tracking-[0.2em] text-muted-foreground" style={{
                letterSpacing: "0.2em"
              }}>
                    {detail.label}
                  </dt>
                  <dd className="font-default text-foreground text-lg leading-snug">
                    — {detail.value}
                  </dd>
                </div>)}
            </dl>

            {}
            <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
              <Link to="https://maps.google.com/?q=The+Glasshouse+at+Willow+Creek+Ohlson+Estate" newTab className="font-default font-semibold text-primary text-base hover:text-primary/80 transition-colors duration-300 inline-flex items-center gap-1 group">
                View Directions
                <ArrowUpRight className="size-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>

              <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-7 py-6 h-auto font-default font-semibold text-base tracking-wide shadow-md">
                <Link to="/EventDetailsPage">RSVP & Details</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-6 lg:col-start-7 transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative rounded-md overflow-hidden shadow-lg bg-card aspect-[4/5] md:aspect-[5/6] lg:aspect-[4/5] border border-border">
              {}
              <div className="absolute inset-0 bg-[hsl(135_25%_94%)]">
                {}
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
                  {}
                  <rect width="400" height="500" fill="hsl(135 25% 94%)" />

                  {}
                  <g opacity="0.4">
                    <rect x="40" y="60" width="110" height="80" fill="hsl(135 20% 90%)" />
                    <rect x="170" y="40" width="90" height="120" fill="hsl(135 20% 88%)" />
                    <rect x="280" y="80" width="100" height="100" fill="hsl(135 20% 92%)" />
                    <rect x="30" y="180" width="140" height="100" fill="hsl(135 20% 90%)" />
                    <rect x="190" y="200" width="80" height="90" fill="hsl(135 20% 91%)" />
                    <rect x="290" y="220" width="90" height="110" fill="hsl(135 20% 89%)" />
                    <rect x="50" y="320" width="120" height="140" fill="hsl(135 20% 92%)" />
                    <rect x="190" y="320" width="100" height="80" fill="hsl(135 20% 90%)" />
                    <rect x="310" y="360" width="70" height="100" fill="hsl(135 20% 91%)" />
                  </g>

                  {}
                  <g stroke="hsl(135 20% 85%)" strokeWidth="1" fill="none" opacity="0.85">
                    <line x1="0" y1="160" x2="400" y2="170" />
                    <line x1="0" y1="300" x2="400" y2="295" />
                    <line x1="0" y1="430" x2="400" y2="440" />
                    <line x1="160" y1="0" x2="170" y2="500" />
                    <line x1="280" y1="0" x2="290" y2="500" />
                  </g>

                  {}
                  <g stroke="hsl(135 20% 85%)" strokeWidth="0.5" fill="none" opacity="0.6">
                    <line x1="0" y1="90" x2="400" y2="95" />
                    <line x1="0" y1="230" x2="400" y2="225" />
                    <line x1="0" y1="370" x2="400" y2="375" />
                    <line x1="90" y1="0" x2="100" y2="500" />
                    <line x1="220" y1="0" x2="230" y2="500" />
                    <line x1="340" y1="0" x2="350" y2="500" />
                  </g>

                  {}
                  <line x1="180" y1="240" x2="320" y2="320" stroke="hsl(145 30% 25%)" strokeWidth="1.5" opacity="0.3" />

                  {}
                  <g transform="translate(225, 270)">
                    {}
                    <g stroke="hsl(145 30% 25%)" strokeWidth="2" strokeLinecap="round">
                      <line x1="-8" y1="-8" x2="8" y2="8" />
                      <line x1="8" y1="-8" x2="-8" y2="8" />
                    </g>
                    {}
                    <circle cx="0" cy="0" r="2" fill="hsl(145 30% 25%)" />
                  </g>

                  {}
                  <text x="245" y="276" fontFamily="JetBrains Mono, monospace" fontSize="9" fill="hsl(145 30% 25%)" letterSpacing="2" fontWeight="700">
                    THE GLASSHOUSE
                  </text>
                </svg>

                {}
                <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-primary/5 pointer-events-none" />
              </div>

              {}
              <Dialog>
                <DialogTrigger asChild>
                  <Button className="absolute bottom-5 right-5 bg-background/95 backdrop-blur-sm text-primary hover:bg-background rounded-md px-4 py-2 h-auto font-mono text-[0.75rem] font-bold uppercase tracking-[0.2em] shadow-md border border-border" style={{
                  letterSpacing: "0.2em"
                }}>
                    Map View
                    <Plus className="size-3.5 ml-1" />
                  </Button>
                </DialogTrigger>
                <DialogContent className="max-w-5xl w-[95vw] h-[85vh] p-0 overflow-hidden rounded-md border-border">
                  <DialogTitle className="sr-only">Welcome Baby Ohlson Venue Map</DialogTitle>
                  <div className="relative w-full h-full bg-muted">
                    <iframe title="Baby Shower Venue Location" src="https://www.openstreetmap.org/export/embed.html?bbox=-118.4200%2C34.0600%2C-118.4000%2C34.0800&layer=mapnik&marker=34.0736%2C-118.4100" className="w-full h-full border-0" loading="lazy" />
                    <div className="absolute top-5 left-5 bg-background/95 backdrop-blur-sm rounded-md px-5 py-3 shadow-md border border-border">
                      <p className="font-mono text-[0.65rem] font-bold uppercase tracking-[0.2em] text-muted-foreground mb-1" style={{
                      letterSpacing: "0.2em"
                    }}>
                        The Ohlson Estate
                      </p>
                      <p className="font-default font-semibold text-foreground text-base flex items-center gap-1.5">
                        <MapPin className="size-3.5 text-primary" />
                        42 Heritage Lane, CA
                      </p>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>

            {}
            <p className="font-mono text-[0.75rem] font-bold uppercase tracking-[0.25em] text-muted-foreground mt-5 text-right" style={{
            letterSpacing: "0.25em"
          }}>
              Ohlson Estate — California
            </p>
          </div>
        </div>
      </div>
    </section>;
}